import {ChangeDetectorRef, Injectable} from "@angular/core";
import {AuthService, HelpDataService} from "@lib/services";
import {Observable, of} from "rxjs";
import {Router} from "@angular/router";
import {UserRoleEnum} from "@ui/directives/access/user-role.enum";
import {Config} from "@core/const/config";
import {filter, startWith, switchMap} from "rxjs/operators";

@Injectable()
export class AppInitializer {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly helpDataService: HelpDataService
  ) {
  }

  public load(): Promise<void> {
    return new Promise<void>(resolve => {
      this.authService.userLoggedIn$
        .pipe(startWith(this.authService.getUser()), switchMap(() => of(this.authService.getUser())))
        .subscribe(user => {
          if (!user || (user && !user.hasOwnProperty('roles'))) {
            this.router.navigate(['/', 'login']);
            resolve();
            return;
          }

          if (user.roles.indexOf(UserRoleEnum.SYS_HI_LVL) === -1) {
            Config.defaultRoute = 'incidents';
          }

          this.authService.loggedUser$.next(user);

          resolve();
        });
    });
  }

  private makeTestRequest(): Observable<any> {
    return this.helpDataService.getUnreadMessagesCount();
  }
}
